module.exports = __webpack_public_path__ + "ace3b4c82f83de7f3cd323e734de11eb.svg";